import React from "react";
import { useNavigate } from "react-router-dom";
import { FaAngleRight, FaCheck } from "react-icons/fa";
import "./SubFooterBanner.css";

const SubFooterBanner = () => {
  const navigate = useNavigate();

  return (
    <aside className="sfb">
      <div className="sfb-inner">
        <div className="sfb-left">
          <span className="sfb-kicker">Looking for expert help?</span>

          <h3 className="sfb-title">
            Get fast, friendly tech & web support—without the headache.
          </h3>

          <p className="sfb-text">
            From printers and security to websites, CRMs, and tools—our team helps
            you fix issues, stay secure, and keep everything running smoothly.
          </p>

          <ul className="sfb-points">
            <li><FaCheck /> Remote troubleshooting</li>
            <li><FaCheck /> Quick issue resolution</li>
            <li><FaCheck /> Safe & secure support</li>
            <li><FaCheck /> Help with apps, web & systems</li>
          </ul>
        </div>

        <div className="sfb-right">
          <button className="sfb-btn" onClick={() => navigate("/contact")}>
            Request Support <FaAngleRight />
          </button>
          <small className="sfb-note">
            No tech jargon. No long waits. Clear fixes you can trust.
          </small>
        </div>
      </div>
    </aside>
  );
};

export default SubFooterBanner;
